<template>
  <button
    type="button"
    class="btn btn-primary btn-block p-2 btn-notifications"
    @click.prevent="$root.isPushEnabled ? unsubscribe() : subscribe()"
	v-text="$root.isPushEnabled ? this.$t('translations.disable_notifications') : this.$t('translations.enable_notifications')"
	:disabled="disabled == 1 ? true : false"
  ></button>
</template>

<script>
import axios from "axios";

export default {
	data: function() {
		return {
			registration: null,
			currentPermissionState: null,
			disabled: 0,
		};
	},

  	mounted() {
        console.log("isPushEnabled: " + this.$root.isPushEnabled)
	},

	computed: {
	},

	watch: {},

  	methods: {
        subscribe () {
            try {
                navigator.serviceWorker.ready.then(registration => {
                    const options = { userVisibleOnly: true }
                    const vapidPublicKey = window.environment_settings.MIX_VAPID_PUBLIC_KEY
                    if (vapidPublicKey) {
                        options.applicationServerKey = this.urlBase64ToUint8Array(vapidPublicKey)
                    }
                    registration.pushManager.subscribe(options)
                    .then(subscription => {
                        this.$root.isPushEnabled = true
                        this.updateSubscription(subscription);
                    })
                    .catch(e => {
                        if (Notification.permission === 'denied') {
                            console.log('Permission for Notifications was denied')
                            this.pushButtonDisabled = true
                        } else {
                            console.log('Unable to subscribe to push.', e)
                            this.pushButtonDisabled = false
                        }
                    })
                })
            }
            catch(e) {
                console.error("Error subscribing.")
                // We ignore any ReferenceError exceptions here.
            }
        },
        /**
         * Send a request to the server to update user's subscription.
         *
         * @param {PushSubscription} subscription
         */
        updateSubscription (subscription) {
            const key = subscription.getKey('p256dh')
            const token = subscription.getKey('auth')
            const data = {
                endpoint: subscription.endpoint,
                key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
            }
            this.loading = true
            axios.post(this.$root.apiBase + "/usernotificationsettings", data)
                .then(() => {
                    // @todo Andy, do we need a loading spinner?
                    //this.loading = false
                })
        },
        /**
         * Unsubscribe from push notifications.
         */
        unsubscribe () {
            try {
                navigator.serviceWorker.ready.then(registration => {
                    registration.pushManager.getSubscription().then(subscription => {
                    if (!subscription) {
                        this.$root.isPushEnabled = false
                        return
                    }
                    subscription.unsubscribe().then(() => {
                        this.deleteSubscription(subscription)
                        this.$root.isPushEnabled = false
                    }).catch(e => {
                        console.log('Unsubscription error: ', e)
                        this.$root.isPushEnabled = false
                    })
                    }).catch(e => {
                        console.log('Error thrown while unsubscribing.', e)
                    })
                });
            }
            catch(e) {
                console.error("Error unsubscribing.")
                // We ignore any ReferenceError exceptions here.
            }
        },
        deleteSubscription (subscription) {
            //this.loading = true
            axios.delete(this.$root.apiBase + "/usernotificationsettings/0", { data: { endpoint: subscription.endpoint }})
                .then(() => {
                    this.loading = false
                })
        },
        /**
         * https://github.com/Minishlink/physbook/blob/02a0d5d7ca0d5d2cc6d308a3a9b81244c63b3f14/app/Resources/public/js/app.js#L177
         *
         * @param  {String} base64String
         * @return {Uint8Array}
         */
        urlBase64ToUint8Array (base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/')
            const rawData = window.atob(base64)
            const outputArray = new Uint8Array(rawData.length)
            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i)
            }
            return outputArray
        },
	}
};
</script>
